import e from"styled-components";import{theme as i}from"../../../theme.js";const a=e.div`
  padding: ${i.spacing*4}px;
  box-shadow: ${i.boxShadow};
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  a {
    color: inherit;
    text-decoration: unset;
  }
`,n=e.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .divider {
    display: none;
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    flex-direction: column;
    gap: ${i.spacing*4}px;
    align-items: flex-start;
    .divider {
      display: block;
      width: 100%;
    }
  }
`,t=e.div`
  display: flex;
  gap: ${i.spacing*4}px;
  align-items: center;
  .wrapper {
    display: flex;
    align-items: center;
    gap: ${i.spacing*2}px;
    .overall {
      font-size: 16px;
      font-weight: 700;
      color: ${i.colors.gray[900]};
      line-height: 24px;
    }
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    justify-content: space-between;
    width: 100%;
  }
`,r=e.button`
  width: 40px;
  height: 40px;
  background-color: unset;
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: ${i.colors.gray[200]};
  }
  > svg {
    width: 20px;
    height: 20px;
    transition: all 0.2s ease-in-out;
    transform: ${({expanded:o})=>o?"rotate(180deg)":"unset"};
  }
`,p=e.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${i.spacing*2}px;
`,s=e.div`
  display: flex;
  align-items: center;
  gap: ${i.spacing*3}px;
  align-items: center;
  padding: ${i.spacing*2}px ${i.spacing*3}px;
  border-radius: ${i.radius}px;
  background-color: ${i.colors.gray[100]};
  > span {
    font-size: 12px;
    font-weight: bold;
    &.rate {
      color: ${i.colors.primary[500]};
      display: flex;
      align-items: center;
      gap: ${i.spacing}px;
      > svg {
        width: 14px;
        height: 14px;
        stroke: ${i.colors.primary[500]};
        > g, path {
          fill: unset;
        }
      }
    }
    &.name {
      color: ${i.colors.gray[900]};
    }
  }
`,l=e.p`
  margin: 0;
  line-height: 24px;
  color: ${i.colors.gray[500]};
`,g=e.div`
  position: relative;
  .main {
    position: relative;
    z-index: 1;
  }
  .additional {
    position: absolute;
    bottom: -6px;
    right: -6px;
    z-index: 2;
    border: 2px solid ${i.colors.shades[0]};
    background-color: ${i.colors.gray[300]};

  }
`,d=e.div`
  display: grid;
  grid-template-columns: 70px 1fr;
  align-items: center;
  grid-gap: ${i.spacing*4}px;
`,c=e.div`
  display: flex;
  flex-direction: column;
  &.gap {
    &--4 {
      gap: ${i.spacing}px;
    }
    &--16 {
      gap: ${i.spacing*4}px;
    }
  }
`,x=e.span`
  font-size: 12px;
  color: ${i.colors.gray[400]};
`,h=e.div`
  display: flex;
  align-items: center;
  gap: ${i.spacing}px;
  > span {
    font-size: 16px;
    line-height: 24px;
    color: ${i.colors.gray[900]};
  }
  > svg {
    width: 18px;
    height: 18px;
    > g,
    path {
      fill: ${i.colors.gray[900]};
    }
  }
`,f=e.span`
  font-size: 16px;
  line-height: 24px;
  color: ${i.colors.gray[900]};
  font-weight: 700;
  > a {
    font-size: 16px;
    line-height: 24px;
    color: ${i.colors.gray[900]};
    font-weight: 700;
    display: block;
  }
`,y=e.div`
  display: flex;
  align-items: center;
  gap: ${i.spacing*2}px;
  .by-who {
    font-size: 16px;
    line-height: 24px;
    color: ${i.colors.gray[900]};
  }
`;export{h as ActionTypeContainer,g as AvatarContainer,y as ByWhoContainer,a as Container,x as Date,l as Description,r as ExpandButton,n as HeaderContainer,t as HeaderDetails,c as ListContainer,f as ReviewedUser,s as StatContainer,p as StatsContainer,d as UserContainer};
